export default () => {
    const openAssetsAccordions = () => {
        document.querySelectorAll('.assets-wrapper').forEach((a) => {
            const trigger = a.querySelector('[data-trigger-accordion]');
            const panel = a.querySelector('[data-panel-accordion]');

            trigger.setAttribute('aria-expanded', 'true');
            trigger.setAttribute('data-state', 'expanded');
            panel.setAttribute('data-state', 'expanded');
        });
    };

    const closeAssetsAccordions = () => {
        document.querySelectorAll('.assets-wrapper').forEach((a) => {
            const trigger = a.querySelector('[data-trigger-accordion]');
            const panel = a.querySelector('[data-panel-accordion]');

            trigger.setAttribute('aria-expanded', 'false');
            trigger.setAttribute('data-state', 'collapsed');
            panel.setAttribute('data-state', 'collapsed');
        });
    };

    const applyAssetStyles = (element) => {
        element.style.fontWeight = 'bold';
        element.querySelector('.asset__title').style.backgroundColor = '#ECEDF5';
        element.querySelector('.asset__description').style.backgroundColor = '#ECEDF5';
    };

    const boldAssets = (value, type) => {
        document.querySelectorAll('.asset').forEach((asset) => {
            const isTitleMatch = type === 'assetsPast' && asset.dataset.title === value;
            const isCategoryMatch = type === 'categoryPast' && (() => {
                const categories = value.replaceAll(', ', ',').split(',');
                const categoryElement = asset.querySelector('.asset__category');
                return categoryElement && categories.includes(categoryElement.innerText.trim());
            })();

            if (isTitleMatch || isCategoryMatch) {
                applyAssetStyles(asset);
            }
        });
    };

    const unboldAssets = () => {
        document.querySelectorAll('.asset').forEach((a) => {
            a.removeAttribute('style');
            a.querySelector('.asset__title').removeAttribute('style');
            a.querySelector('.asset__description').removeAttribute('style');
        });
    };

    const getSelectionState = () => {
        const assetSelect = document.getElementById('assetsPast');
        const categoryButton = document.getElementById('categoryPast-button');

        return {
            isAllAssets: assetSelect ? assetSelect.value === 'All Poster and Presentation Names' : true,
            isAllCategories: categoryButton ? categoryButton.innerText === 'All Categories' : true,
            assetValue: assetSelect ? assetSelect.value : '',
            categoryValue: categoryButton ? categoryButton.innerText : ''
        };
    };

    const handleAssetChange = () => {
        const state = getSelectionState();
        const isAllSelected = state.isAllAssets && state.isAllCategories;

        if (isAllSelected) {
            closeAssetsAccordions();
            unboldAssets();
        } else {
            openAssetsAccordions();
            unboldAssets();
            if (!state.isAllAssets) {
                boldAssets(state.assetValue, 'assetsPast');
            }
            if (!state.isAllCategories) {
                boldAssets(state.categoryValue, 'categoryPast');
            }
        }
    };

    if (document.getElementById('assetsPast') !== null) {
        document.getElementById('assetsPast').addEventListener('change', handleAssetChange);
    }

    if (document.getElementById('categoryPast') !== null) {
        document.getElementById('categoryPast').addEventListener('change', handleAssetChange);
    }
};
